import { Box, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import AddButton from "components/common/AddButton";
import { useDiscussions } from "hooks/useDiscussions";
import { useIsDesktop } from "hooks/useMediaQueries";
import { useScrollParentToTop } from "hooks/useScrollParentToTop";
import { useTypingMessagesSocket } from "hooks/useTypingMessagesSocket";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "stores/authStore";
import { ChatRoomsHeader } from "./ChatRoomsHeader";
import { DiscussionListItem } from "./DiscussionListItem";
import { ModalNewPrivateDiscussion } from "./ModalNewPrivateDiscussion";
import { getFilteredDiscussions } from "./chatRooms.utils";

interface ChatRoomsProps {
  onSelect: (discussionId: string, contextId?: string | null) => void;
  onClose?: () => void;
}

const ChatRooms: React.FC<ChatRoomsProps> = ({ onSelect, onClose }) => {
  const { t } = useTranslation("discussions");
  const isDesktop = useIsDesktop();
  const rootRef = useScrollParentToTop();

  const currentUserId = useAuthStore(state => state.currentUserId);
  const typingMessages = useTypingMessagesSocket();
  const [search, setSearch] = useState("");
  const [
    isNewDiscussionOpen,
    { open: openNewDiscussion, close: closeNewDiscussion },
  ] = useDisclosure(false);
  const {
    discussions,
    isPending: discussionsIsLoading,
    isSuccess,
  } = useDiscussions();

  const filteredDiscussions = getFilteredDiscussions(discussions, search, t);

  return (
    <Box ref={rootRef} className="bg-white">
      <ChatRoomsHeader
        search={search}
        onSearchChange={setSearch}
        isDesktop={isDesktop}
        onNewDiscussion={openNewDiscussion}
        onClose={onClose}
      />
      {discussionsIsLoading && <Text>{t("discussionLoading")}</Text>}
      {isSuccess &&
        filteredDiscussions.map(discussion => (
          <DiscussionListItem
            key={discussion.id}
            discussion={discussion}
            currentUserId={currentUserId}
            typingMessage={
              discussion.id ? typingMessages[discussion.id] : undefined
            }
            onSelect={onSelect}
          />
        ))}
      {!isDesktop && <AddButton onClick={openNewDiscussion} zIndex={350} />}
      {isNewDiscussionOpen && (
        <ModalNewPrivateDiscussion
          onClose={closeNewDiscussion}
          onSelect={onSelect}
        />
      )}
    </Box>
  );
};

export default ChatRooms;
